module.exports = __webpack_public_path__ + "img/style_model_preview_678.3ad6e555.jpg";